// Pure helpers for traversing the PRO tree. Kept outside the components so
// they can be reused by future slices (PRD 04/05/06) without importing React.

import type { ProTreeNode } from '@/features/pro-tree/types/pro-tree.types';

export function findItemNode(
  tree: ProTreeNode[],
  id: string,
): ProTreeNode | null {
  if (!Array.isArray(tree)) return null;
  for (const node of tree) {
    if (node.id === id && node.type === 'item') return node;
    if (node.children) {
      const found = findItemNode(node.children, id);
      if (found) return found;
    }
  }
  return null;
}

// SHCT-390 — returns the ancestor→item chain for an item id (the item's `pid`),
// e.g. [area, sub, item]. Used to deep-link into the tree from PRO Item Design:
// expand every ancestor and select the item. Returns null when the id isn't an
// item in the tree (e.g. an unpublished item not yet in the shared tree).
export function findPathToItem(
  tree: ProTreeNode[],
  id: string,
): ProTreeNode[] | null {
  if (!Array.isArray(tree)) return null;
  for (const node of tree) {
    if (node.id === id && node.type === 'item') return [node];
    if (node.children) {
      const childPath = findPathToItem(node.children, id);
      if (childPath) return [node, ...childPath];
    }
  }
  return null;
}
